module.exports = __webpack_public_path__ + "img/guiyang.1d860247.jpg";